var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("rb-modal", {
    attrs: {
      show: _vm.visible,
      "handle-close": _vm.handleClose,
      "modal-class-container": "rb-modal-container--small",
      "modal-wrapper-class": _vm.modalWrapperClass,
    },
    scopedSlots: _vm._u([
      {
        key: "modal-content",
        fn: function () {
          return [
            _vm.loginFormIsVisible
              ? _c("rb-login-form", {
                  attrs: { "is-frame-advisor": _vm.isFrameAdvisor },
                  on: {
                    close: _vm.handleClose,
                    showRegisterForm: _vm.showRegisterForm,
                  },
                })
              : _c("rb-register-form", {
                  attrs: { "is-frame-advisor": _vm.isFrameAdvisor },
                  on: {
                    close: _vm.handleClose,
                    showLoginForm: _vm.showLoginForm,
                  },
                }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }